import React, { useState } from "react";
import { FaUser, FaLock, FaPhone } from "react-icons/fa";
import { registerUser, loginUser } from "../services/api";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import './AuthPage.css';

const AuthPage = () => {
    const [isLogin, setIsLogin] = useState(true);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        password: "",
    });
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateForm = () => {
        if (!formData.email || !formData.password) {
            return "Please fill in all required fields.";
        }
        if (!isLogin && (!formData.name || !formData.phone)) {
            return "Please fill in your name and phone number.";
        }
        if (!isLogin && !/^\d{10}$/.test(formData.phone)) {
            return "Please enter a valid 10-digit phone number.";
        }
        return null;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationError = validateForm();
        if (validationError) {
            setMessage(validationError);
            return;
        }

        setLoading(true);
        setMessage("");

        try {
            let response;
            if (isLogin) {
                response = await loginUser(formData.email, formData.password);
            } else {
                response = await registerUser(formData);
            }

            if (response && response.token) {
                localStorage.setItem("authToken", response.token);
                login(response.token);
                navigate("/profile");
            } else {
                setMessage(response?.msg || "An error occurred. Please try again.");
            }
        } catch (error) {
            console.error("Login error:", error);
            setMessage(error.response?.data?.msg || "An unexpected error occurred.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container d-flex justify-content-center align-items-center w-500">
            <div className="card p-4 shadow-lg rounded">
                <div className="tabs d-flex justify-content-center mb-4">
                    <button
                        className={`tab-btn ${isLogin ? "active" : ""} btn btn-outline-primary me-2`}
                        onClick={() => setIsLogin(true)}
                        disabled={loading}
                    >
                        Login
                    </button>
                    <button
                        className={`tab-btn ${!isLogin ? "active" : ""} btn btn-outline-primary`}
                        onClick={() => setIsLogin(false)}
                        disabled={loading}
                    >
                        Signup
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="auth-form">
                    {!isLogin && (
                        <div className="mb-3">
                            <label className="form-label">Name</label>
                            <div className="input-group">
                                <span className="input-group-text">
                                    <FaUser />
                                </span>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div>
                        </div>
                    )}
                    <div className="mb-3">
                        <label className="form-label">Email</label>
                        <div className="input-group">
                            <span className="input-group-text">
                                <i className="bi bi-envelope"></i>
                            </span>
                            <input
                                type="email"
                                name="email"
                                placeholder="visitor@ngowaters.com"
                                value={formData.email}
                                onChange={handleChange}
                                className="form-control"
                                required
                            />
                        </div>
                    </div>
                    {!isLogin && (
                        <div className="mb-3">
                            <label className="form-label">Phone</label>
                            <div className="input-group">
                                <span className="input-group-text">
                                    <FaPhone />
                                </span>
                                <input
                                    type="text"
                                    name="phone"
                                    placeholder="9876543210"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div>
                        </div>
                    )}
                    <div className="mb-3">
                        <label className="form-label">Password</label>
                        <div className="input-group">
                            <span className="input-group-text">
                                <FaLock />
                            </span>
                            <input
                                type="password"
                                name="password"
                                placeholder="Visitor"
                                value={formData.password}
                                onChange={handleChange}
                                className="form-control"
                                required
                            />
                        </div>
                    </div>

                    <button type="submit" className="btn btn-primary w-100 mt-3" disabled={loading}>
                        {loading ? "Processing..." : isLogin ? "Login" : "Signup"}
                    </button>
                </form>

                {message && <p className="mt-3 text-center text-danger">{message}</p>}
            </div>
        </div>
    );
};

export default AuthPage;
